import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './box-cta.module.css';
import { texts } from './box-cta.texts';
export const BoxCTAContent = ({ children, leftSlot, rightSlot, loading, loadingLabel = texts.label.loading })=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            leftSlot && /*#__PURE__*/ _jsx("span", {
                className: styles.slot,
                children: leftSlot
            }),
            children && /*#__PURE__*/ _jsx("span", {
                className: styles.text,
                children: loading ? loadingLabel : children
            }),
            rightSlot && /*#__PURE__*/ _jsx("span", {
                className: styles.slot,
                children: rightSlot
            })
        ]
    });

//# sourceMappingURL=box-cta-content.js.map